const ShieldCheckIcon = ({ size = 14, className = "", ...props }) => {
    return (
        <svg
            width={size}
            height={size * (18 / 14)}
            viewBox="0 0 14 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M13.6486 4.95661C13.6297 4.51815 13.6297 4.09961 13.6297 3.68108C13.6297 3.34226 13.3834 3.08317 13.0614 3.08317C10.6932 3.08317 8.89349 2.36568 7.39685 0.831051C7.16951 0.611818 6.8285 0.611818 6.60116 0.831051C5.10452 2.36568 3.30476 3.08317 0.936655 3.08317C0.614593 3.08317 0.36831 3.34226 0.36831 3.68108C0.36831 4.09961 0.36831 4.51815 0.349365 4.95661C0.273586 9.14196 0.159916 14.8819 6.80956 17.2934L6.999 17.3333L7.18845 17.2934C13.8191 14.8819 13.7244 9.16189 13.6486 4.95661ZM6.54433 10.7563C6.43066 10.856 6.29805 10.9158 6.14649 10.9158H6.12754C5.97598 10.9158 5.82442 10.836 5.7297 10.7165L3.96783 8.66364L4.82035 7.86643L6.20332 9.48078L9.27239 6.41152L10.0491 7.28845L6.54433 10.7563Z"
                fill="#01BBFE"
            />
        </svg>
    );
};

export default ShieldCheckIcon;